import React from 'react';

import PropTypes from 'prop-types';

// Material UI Imports
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// Material Icons Imports
import IconArchive from '@material-ui/icons/ArchiveOutlined';
import IconUnarchive from '@material-ui/icons/UnarchiveOutlined';

import axios from 'axios';
import Button from '@material-ui/core/Button';
import _ from 'lodash';
//Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';



const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: 0,
    position: 'relative',

  },
  fabProgress: {
    position: 'absolute',
    top: 5,
    left: 5,
    zIndex: 0,
  },
})

class UserTableActions extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };


  _handleArchive = async (user, handler) => {
    const userId = user.id;
    const active = !user.active;
    await this.props.mutationMarkAsDeleted({
      variables: {
        userId,
        active
      }
    })
      .catch((e) => {
        console.log(e)
      })
      .then(this.handleClose)
      .then(handler)
  }


  render() {

    const { showing, downloading, archiving } = this.state;
    const { classes, user, handler } = this.props;
    const tooltipTitle = user.active === true ? "Archive" : "Unarchive";
    const dialogMessage = user.active ? "Archived users are marked as inactive and only appears on the archived section" : "This action will mark the user as active and will show it again on all sections";

    return (
      <div className={classes.root}>
        <Tooltip title={tooltipTitle}>
          <div className={classes.wrapper}>
            <IconButton onClick={this.handleClickOpen}>
              {user.active ? <IconArchive /> : <IconUnarchive />}
            </IconButton>
          </div>
        </Tooltip>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{tooltipTitle} the user {user.fullName}?</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {dialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this._handleArchive.bind(this, user, handler)} color="primary" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

      </div >
    );
  }
}
UserTableActions.propTypes = {
  classes: PropTypes.object.isRequired,
};

const MUTATION_MARK_AS_ARCHIVED = gql`
mutation updateUser($userId: ID!,$active:Boolean!){
    updateUser(userId: $userId, input:{active: $active}){
    id
  }
}
`;

export default compose(
  graphql(MUTATION_MARK_AS_ARCHIVED, {
    name: 'mutationMarkAsDeleted',
    options: {
      refetchQueries: ["all_users_query", "all_inactive_users_query"]
    }
  }),
  withStyles(styles)
)(UserTableActions);


// WEBPACK FOOTER //
// src/components/innerComponents/UserTableActions.js